import { IUser } from 'src/hooks/useUsers'
import { IUser as IAccountUser } from 'src/hooks/useAccount'
import { IGetAccountData, IGetUserData } from 'src/services/auth/users'

export const getUserPrimaryLabel = (
  user:
    | IUser
    | IAccountUser
    | IGetAccountData
    | IGetUserData
    | undefined
    | { identifier?: string; info?: { firstName?: string; lastName?: string } }
) => {
  const firstName = user?.info?.firstName?.trim()
  const lastName = user?.info?.lastName?.trim()

  if (firstName || lastName) {
    return `${firstName}${firstName ? ' ' : ''}${lastName}`
  }

  if (user?.identifier) {
    return user.identifier
  }

  return 'Unknown'
}
